import React, { Component } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import {
  getSalesOrders,
  cancelSalesOrder,
} from "../../../../services/sales/salesOrderService";
import ContentLayout from "../../../../partials/content/ContentLayout";
import Illustration from "../../../../partials/content/Illustration";
import { Badge } from "react-bootstrap";
import { Card } from "primereact/card";
import NumberFormat from "react-number-format";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import Swal from "sweetalert2";
import withGlobalData from "../../common/withGlobalData";
class SalesOrderList extends Component {
  state = {
    reload: this.props.globalData.reload,
    auth: {},
    salesOrders: [],
    fullyBilleds: 0,
    partiallyBilleds: 0,
    unbilleds: 0,
    salesOrderDetailColumn: [
      {
        header: "Expected Delivery Date",
        field: "expDeliveryDate",
        type: "date",
      },
      {
        header: "Quotation ID",
        field: "quotationCode",
        type: "string",
      },
      {
        header: "Sales Agent",
        field: "salesName",
        type: "string",
      },
      {
        header: "Customer PO Number",
        field: "customerPoNo",
        type: "string",
      },
      {
        header: "Exchange Rate To Base Currency",
        field: "exchangeRate",
        type: "currency",
      },
      {
        header: "Approval Status",
        field: "approvalStatusDesc",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getSalesOrders();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getSalesOrders();
      this.setState({ reload: globalData.reload });
    }
  }

  async getSalesOrders() {
    const response = await getSalesOrders(0, 0);
    const { data, auth } = response.data;
    this.setState({ salesOrders: data.salesOrders, auth });
    const fullyBilleds = data.salesOrders.filter(
      (salesOrder) => salesOrder.invoiceStatus === 3
    );
    const partiallyBilleds = data.salesOrders.filter(
      (salesOrder) => salesOrder.invoiceStatus === 2
    );
    const unbilleds = data.salesOrders.filter(
      (salesOrder) => salesOrder.invoiceStatus === 1
    );
    this.setState({ fullyBilleds: fullyBilleds.length });
    this.setState({ partiallyBilleds: partiallyBilleds.length });
    this.setState({ unbilleds: unbilleds.length });
  }

  render() {
    const {
      salesOrders,
      auth,
      salesOrderDetailColumn,
      fullyBilleds,
      partiallyBilleds,
      unbilleds,
    } = this.state;
    const actionButtons = [
      {
        title: "",
        color: "label-brand",
        icon: "fas fa-backward",
        onClick: () => {
          this.props.history.push("/menu");
        },
      },
    ];
    if (auth.create) {
      actionButtons.push({
        title: "New Sales Order",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          this.props.history.push("/sales/sales-order/sales-order-form");
        },
      });
    }
    return (
      <React.Fragment>
        <PageSubHeader
          title="Sales Order List"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/sales/sales-order/sales-order-list",
              title: "Sales Orders",
              active: true,
            },
          ]}
          actionButtons={actionButtons}
        />
        <div className="row mb-3">
          <div className="col-sm-4 col-md-4 col-lg-4">
            <Card id="overviewcard" className="border-success">
              <div className="kt-widget4">
                <div className="kt-widget4__item ">
                  <span className="kt-widget4__icon">
                    <i className="fas fa-check-circle kt-font-success" />
                  </span>
                  <div className="kt-widget4__info ">
                    <div className="kt-widget4__highlighttitle">
                      FULLY BILLED
                    </div>
                  </div>
                  <Badge variant="success">{fullyBilleds}</Badge>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <Card id="overviewcard" className="border-warning">
              <div className="kt-widget4">
                <div className="kt-widget4__item ">
                  <span className="kt-widget4__icon">
                    <i className="fas fa-exclamation-circle kt-font-warning" />
                  </span>
                  <div className="kt-widget4__info ">
                    <div className="kt-widget4__highlighttitle">
                      PARTIALLY BILLED
                    </div>
                  </div>
                  <Badge variant="warning">{partiallyBilleds}</Badge>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <Card id="overviewcard" className="border-danger">
              <div className="kt-widget4">
                <div className="kt-widget4__item ">
                  <span className="kt-widget4__icon">
                    <i className="fas fa-times-circle kt-font-danger" />
                  </span>
                  <div className="kt-widget4__info ">
                    <div className="kt-widget4__highlighttitle">UNBILLED</div>
                  </div>
                  <Badge variant="danger">{unbilleds}</Badge>
                </div>
              </div>
            </Card>
          </div>
        </div>
        <ContentLayout>
          {salesOrders.length ? (
            <React.Fragment>
              <CustomDataTable
                data={salesOrders}
                dataDetailColumns={salesOrderDetailColumn}
                onRefreshData={() => {
                  this.getSalesOrders();
                }}
                tableName="salesOrder"
                selectionMode="checkbox"
                columns={[
                  {
                    selectionMode: "multiple",
                  },
                  {
                    header: "Sales Order ID",
                    field: "salesOrderCode",
                    body: (rowData) => {
                      if (rowData.approvalStatus === 1) {
                        return (
                          <React.Fragment>
                            <span>
                              <span>{rowData.salesOrderCode}</span>
                              <BootstrapTooltip title="Document Waiting For Approval">
                                <span className="ml-2">
                                  <i className="far fa-clock kt-font-warning"></i>
                                </span>
                              </BootstrapTooltip>
                            </span>
                          </React.Fragment>
                        );
                      } else if (rowData.approvalStatus === 2) {
                        return (
                          <React.Fragment>
                            <span>
                              <span>{rowData.salesOrderCode}</span>
                              <BootstrapTooltip title="Document Approved">
                                <span className="ml-2">
                                  <i className="fas fa-check kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                            </span>
                          </React.Fragment>
                        );
                      } else if (rowData.approvalStatus === 3) {
                        return (
                          <React.Fragment>
                            <span>
                              <span>{rowData.salesOrderCode}</span>
                              <BootstrapTooltip title="Document Rejected">
                                <span className="ml-2">
                                  <i className="fas fa-times kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                            </span>
                          </React.Fragment>
                        );
                      } else {
                        return (
                          <React.Fragment>
                            <span>
                              <span>{rowData.salesOrderCode}</span>
                              <BootstrapTooltip title="Document No Need Approval">
                                <span className="ml-2">
                                  <i className="fas fa-check kt-font-primary"></i>
                                </span>
                              </BootstrapTooltip>
                            </span>
                          </React.Fragment>
                        );
                      }
                    },
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Customer Name",
                    field: "customer.customerName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.customer.customerName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Order Date",
                    field: "orderDate",
                    body: (rowData) => formatDate(rowData.orderDate),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Goods Issue Status",
                    field: "giStatusDesc",
                    body: (rowData) => {
                      if (rowData.giStatus === 1) {
                        return (
                          <Badge variant="danger">{rowData.giStatusDesc}</Badge>
                        );
                      } else if (rowData.giStatus === 2) {
                        return (
                          <Badge variant="warning">
                            {rowData.giStatusDesc}
                          </Badge>
                        );
                      } else if (rowData.giStatus === 3) {
                        return (
                          <Badge variant="success">
                            {rowData.giStatusDesc}
                          </Badge>
                        );
                      } else {
                        return (
                          <Badge variant="dark">{rowData.giStatusDesc}</Badge>
                        );
                      }
                    },
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Invoice Status",
                    field: "invoiceStatusDesc",
                    body: (rowData) => {
                      if (rowData.invoiceStatus === 1) {
                        return (
                          <Badge variant="danger">
                            {rowData.invoiceStatusDesc}
                          </Badge>
                        );
                      } else if (rowData.invoiceStatus === 2) {
                        return (
                          <Badge variant="warning">
                            {rowData.invoiceStatusDesc}
                          </Badge>
                        );
                      } else if (rowData.invoiceStatus === 3) {
                        return (
                          <Badge variant="success">
                            {rowData.invoiceStatusDesc}
                          </Badge>
                        );
                      } else {
                        return (
                          <Badge variant="dark">
                            {rowData.invoiceStatusDesc}
                          </Badge>
                        );
                      }
                    },
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Currency",
                    field: "currency.currencyCode",
                    body: null,
                    sortable: true,
                    filter: true,
                    hidden: true,
                  },
                  {
                    header: "Grand Total",
                    field: "grandTotal",
                    body: (rowData) => (
                      <NumberFormat
                        value={rowData.grandTotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {rowData.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Actions",
                    body: (rowData) => (
                      <React.Fragment>
                        {(rowData.approvalProcessID === 0 ||
                          rowData.approvalProcess.statusID === 2 ||
                          rowData.approvalProcess.statusID === 3) &&
                        rowData.invoiceStatus === 1 &&
                        rowData.giStatus === 1 ? (
                          <BootstrapTooltip title="Edit Sales Order">
                            <button
                              type="button"
                              onClick={() => {
                                this.props.history.push(
                                  "/sales/sales-order/edit-sales-order/" +
                                    rowData.ID
                                );
                              }}
                              className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          </BootstrapTooltip>
                        ) : null}
                        <BootstrapTooltip title="Sales Order Detail">
                          <button
                            type="button"
                            onClick={() => {
                              this.props.history.push(
                                "/sales/sales-order/sales-order-detail/" +
                                  rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-list-alt"></i>
                          </button>
                        </BootstrapTooltip>
                        {(rowData.approvalProcessID === 0 ||
                          rowData.approvalProcess.statusID === 2 ||
                          rowData.approvalProcess.statusID === 3) &&
                        rowData.invoiceStatus === 1 &&
                        rowData.giStatus === 1 ? (
                          <BootstrapTooltip title="Delete Sales Order">
                            <button
                              type="button"
                              onClick={(event) =>
                                this.handleDeleteSalesOrder(rowData.ID)
                              }
                              className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          </BootstrapTooltip>
                        ) : null}
                      </React.Fragment>
                    ),
                    sortable: false,
                  },
                ]}
              />
            </React.Fragment>
          ) : (
            <Illustration
              imageSource="INVIFO Sales.png"
              description="Hooray! You're ready to have your first Sales Order!"
              guidance="Hint: manage your sales to achieve a more effective process order"
              descriptionLeftIcon="fas fa-info-circle kt-font-success"
            ></Illustration>
          )}
        </ContentLayout>
      </React.Fragment>
    );
  }

  handleDeleteSalesOrder = (salesOrderID = 0) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Sales Order ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelSalesOrder(salesOrderID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getSalesOrders();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };
}

export default withGlobalData(SalesOrderList);
